import ih from 'immutability-helper';

import * as types from './actionTypes';
import initialState from './initialState';

import { PURGE_ACTIONS } from '../project/actionTypes';

const dictionaryColumnsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PURGE_ACTIONS:
      return ih(state, {
        list: {
          data: {
            items: {
              $set: state.list.data.items.filter(
                o => !action.payload.data.dictionary_columns.includes(o.id),
              ),
            },
          },
        },
      });
    case types.GET_DICTIONARY_COLUMNS_SUCCESS:
      return ih(state, {
        list: {
          paginationOptions: {
            $set: action.payload.paginationOptions,
          },
          isLoading: {
            $set: false,
          },
          data: {
            items: {
              $set: action.payload.dictionaryColumns,
            },
            count: {
              $set: action.payload.count,
            },
          },
        },
      });
    case types.ADD_DICTIONARY_COLUMN_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_DICTIONARY_COLUMN_SUCCESS:
      return ih(state, {
        add: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_DICTIONARY_COLUMN_ERROR:
      return ih(state, {
        add: {
          isLoading: { $set: false },
          error: {
            $set: action.payload.error,
          },
        },
      });
    case types.UPDATE_DICTIONARY_COLUMN_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_DICTIONARY_COLUMN_SUCCESS:
      return ih(state, {
        update: {
          isLoading: { $set: false },
        },
      });
    case types.UPDATE_DICTIONARY_COLUMN_ERROR:
      return ih(state, {
        update: {
          isLoading: { $set: false },
          error: {
            $set: action.payload.error,
          },
        },
      });
    case types.DELETE_DICTIONARY_COLUMN_REQUEST:
      return ih(state, {
        delete: {
          isLoading: { $set: true },
        },
      });
    case types.DELETE_DICTIONARY_COLUMN_SUCCESS:
      return ih(state, {
        delete: {
          isLoading: { $set: false },
        },
      });
    case types.DELETE_DICTIONARY_COLUMN_ERROR:
      return ih(state, {
        delete: {
          isLoading: { $set: false },
          error: {
            $set: action.payload.error,
          },
        },
      });
    default:
      return state;
  }
};

export default dictionaryColumnsReducer;
